const SELECTOR_INPUT = '.phx-select2';

const {jQuery} = window;

export default class Select2 {

    $inputs = {};

    constructor() {
        window.addEventListener('DOMContentLoaded', this.init.bind(this));
    }

    init() {
        this.$inputs = jQuery(SELECTOR_INPUT);

        if (!this.$inputs) {
            return;
        }

        this.$inputs.each(function (index, element) {
            if (element.dataset.select2Options) {
                jQuery(element).select2(JSON.parse(element.dataset.select2Options));
            } else {
                jQuery(element).select2();
            }
        });
    }

}